/* eslint-disable max-len */
import React from 'react'
import classNames from 'classnames'

const TypographyRow = () => {
   return (
      <div
         className={classNames(
            'flex gap-4 p-8 bg-green-100/10 text-green-100 border border-solid border-green-100/10 rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)]'
         )}>
         <div>
            <div className="text-xl font-semibold opacity-70">Heading 1</div>
            <div className="text-lg font-semibold opacity-60">Heading 2</div>
            <div className="text-base font-semibold opacity-50">Heading 3</div>
            <div className="text-xs mt-2 opacity-40">
               Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis egestas pretium aenean pharetra. Orci eu lobortis elementum nibh tellus molestie. Vulputate dignissim suspendisse in est. Vel pharetra vel turpis nunc. Malesuada nunc vel risus commodo. Nisi vitae suscipit tellus mauris. Posuere morbi leo urna molestie at elementum eu. Urna duis convallis convallis tellus. Urna molestie at elementum eu. Nunc sed blandit libero volutpat.
            </div>
         </div>
      </div>
   )
}

const ColorRow = () => {
   return (
      <div
         className={classNames(
            'flex items-center gap-4 p-4 bg-white text-black rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)]'
         )}>
         <div className="flex-0 flex justify-center items-center w-20 h-20 p-2">
            <div className="w-full h-full rounded-full p-1 border border-solid border-neutral-200 shadow-lg">
               <div className="w-full h-full rounded-full bg-green-700" />
            </div>
         </div>
         <div className="flex-1">
            <div className="font-semibold">Highlight Color</div>
            <div className="text-xs opacity-70">
               This is the primary color used for empasis troughout your site, including: buttons, calls to action and accent text.
            </div>
         </div>
      </div>
   )
}

const LogoRow = () => {
   return (
      <div
         className={classNames(
            'flex items-center gap-4 p-4 bg-white text-black rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)]'
         )}>
         <div className="flex-0 flex justify-center items-center w-20 h-20 p-2">
            <img
               className="w-full"
               src="/assets/custom/communities/images/features/theme/1.png"
               alt="Theme"
            />
         </div>
         <div className="flex-1">
            <div className="font-semibold">Primary Logo</div>
            <div className="text-xs opacity-70">
               The primary logo is the logo that is displayed in your Main Menu.
            </div>
         </div>
      </div>
   )
}

export {
   ColorRow,
   LogoRow,
   TypographyRow
}
